import { useCallback, useMemo } from 'react';
import type { ViewabilityConfigCallbackPairs, ViewToken } from 'react-native';

import { usePostViewStore } from '@/shared/store/usePostViewStore';

const VIEWABILITY_CONFIG = {
  minimumViewTime: 500,
  viewAreaCoveragePercentThreshold: 90,
  waitForInteraction: false
} as const;

/**
 * Tracks feed posts as viewed for backend post statistics (SML-222).
 */
export const useTrackFeedPostViews = <T extends { postId?: string }>() => {
  const addPostOverviewViewsEvent = usePostViewStore(
    (state) => state.addPostOverviewViews
  );

  const onViewableItemsChanged = useCallback(
    ({ viewableItems }: { viewableItems: ViewToken<T>[] }) => {
      addPostOverviewViewsEvent(viewableItems.map((v) => v.item.postId));
    },
    [addPostOverviewViewsEvent]
  );

  const viewabilityConfigCallbackPairs =
    useMemo<ViewabilityConfigCallbackPairs>(
      () => [{ onViewableItemsChanged, viewabilityConfig: VIEWABILITY_CONFIG }],
      [onViewableItemsChanged]
    );

  return viewabilityConfigCallbackPairs;
};
